<div class="page-container">
  <div class="table-container mt-4">
    <table class="custom-table">
      <thead>
        <tr>
          <th>Sr.No</th>
          <th>Image</th>
          <th>Product Name</th>
          <th>Product Type</th>
          <th>Affiliate Link</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of filteredProducts">
          <td class="fw-bold">{{ product.srNo }}</td>
          <td>
            <div class="product-img-box">
              <img [src]="product.image" alt="Product" />
            </div>
          </td>
          <td class="fw-bold">{{ product.name }}</td>

          <td>
            <span class="badge" [ngClass]="product.type === 'Combo Product' ? 'bg-primary' : 'bg-success'">
              {{ product.type }}
            </span>
          </td>

          <td>
            <span class="link-text text-muted" title="{{ product.link }}">
              {{ product.link | slice: 0 : 45 }}...
            </span>
          </td>

          <td>
            <button class="btn-copy" (click)="copyLink(product.link)">
              <i class="fa-regular fa-copy"></i> Copy URL
            </button>
          </td>
        </tr>

        <tr *ngIf="filteredProducts.length === 0">
          <td colspan="6" class="no-data-cell text-center py-4">
            <div class="empty-state">
              <h4 class="text-muted">No Products Found</h4>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
